export class SupplierInfo {
    CategoryType: string;
    Category: string;
    Code: string;
    Description: string;
    IsCoveredSupplier: boolean;
}